/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Action
 */
export interface UuidSideAction { 
    /**
     * UUID
     */
    uuid: string;
    /**
     * Side
     */
    side: UuidSideAction.SideEnum;
}
export namespace UuidSideAction {
    export type SideEnum = 'Left' | 'Right';
    export const SideEnum = {
        Left: 'Left' as SideEnum,
        Right: 'Right' as SideEnum
    };
}